const Theme = {
  body_background_color: '#FFFCDD',

  header_border_color: '#652D90',

  logo_image_url: 'explorekahnawake.png',
  logo_height: 100,

  number_font: `'Abhaya Libre', serif`,

  button_font: `'Helvetica', sans-serif`,
  button_text_lineheight: 23.8,
  button_text_size: 15,
  button_padding: '8px 15px',

  button_color: '#7442ac',
  button_hover_color: '#8e5fc2',
  button_hover_text_color: 'white',
  button_hover_border_color: '#8e5fc2',

  text_font: `'Helvetica', sans-serif`,
  text_color: '#48444d',
  text_size: 15,
  text_lineheight: 23.8,

  title_font: `'Abhaya Libre', serif`,
  title_size: 28,
  title_lineheight: 33.6,
  title_weight: 800,

  separator_color: '#652D90',

  footer_border_color: '#eee',
}

export default Theme
